var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.PAGE_INDEX <= _vm.currentPage + 1 && _vm.PAGE_INDEX >= _vm.currentPage - 1 ||
    _vm.PAGE_INDEX === 2 ||
    _vm.PAGE_INDEX === 13)?_c('div',{class:{
    'page-container': true,
    'fade-in': _vm.PAGE_INDEX < _vm.currentPage && _vm.PAGE_INDEX !== _vm.PAGE_AMOUNT - 1,
    'page-active': _vm.PAGE_INDEX === _vm.currentPage,
  },attrs:{"id":'page' + _vm.PAGE_INDEX}},[_c('div',{staticClass:"page-background",style:({
      backgroundColor: _vm.bgColor,
    })},[_vm._t("background")],2),_c('div',{class:{
    'content': true,
    'fly-out': _vm.PAGE_INDEX < _vm.currentPage && _vm.PAGE_INDEX !== _vm.PAGE_AMOUNT - 1,
    }},[_vm._t("content")],2),(_vm.scrollDownArrowFlag && _vm.currentPage === _vm.PAGE_INDEX)?_c('div',{staticClass:"scroll-down-arrow-wrapper"},[_c('ScrollDownArrow')],1):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }